import React from 'react';
import ReactDOM from 'react-dom/client';
import { FeatureAppContainer, FeatureHubContextProvider } from '@feature-hub/react';
import { createFeatureHub } from '@feature-hub/core';
import { defineExternals, loadAmdModule } from '@feature-hub/module-loader-amd';
import FeatureHubAppDefinition from './app/AppDefinition';
import { loadFederatedModule } from '@feature-hub/module-loader-federation';
import { externals } from './app/externals/ExternalLibs';
import { NavigationServiceV1, navigationServiceDefinition } from './app/services/NavigationService';
import { sharedDataServiceDefinition } from './app/services/DataSharingService';
import { createRootLocationTransformer } from '@feature-hub/history-service';
import { defineHistoryService } from '@feature-hub/history-service';
import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';

defineExternals(externals);

const { featureAppManager, featureServices } = createFeatureHub('main:integrator', {
  moduleLoader: async (url, moduleType) =>
    moduleType === 'federated' ? loadFederatedModule(url) : loadAmdModule(url),
  providedExternals: {
    react: process.env.REACT_VERSION as string,
    '@feature-hub/react': process.env.FEATURE_HUB_REACT_VERSION as string,
  },
  featureServiceDefinitions: [
    defineHistoryService(createRootLocationTransformer({ consumerPathsQueryParamName: '/' })),
    navigationServiceDefinition,
    sharedDataServiceDefinition,
  ],
  featureServiceDependencies: {
    'shell:navigation-service': '^1.0.0',
    'api:get-shared-data': '1.0.0',
  },
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
const navigationService = featureServices[navigationServiceDefinition.id] as NavigationServiceV1;

root.render(
  <FeatureHubContextProvider value={{ featureAppManager }}>
    <HistoryRouter history={navigationService.history}>
      <FeatureAppContainer
        featureAppDefinition={FeatureHubAppDefinition}
        featureAppId={'welceom:welcome-fa-template'}
        config={{ data: 'custom data, json object' }}
      />
    </HistoryRouter>
  </FeatureHubContextProvider>
);

// Service Worker Registration - DISABLED
// if ('serviceWorker' in navigator) {
//   window.addEventListener('load', function handleServiceWorkerLoad(): void {
//     (async function registerServiceWorker(): Promise<void> {
//       const { register } = await import('./service-worker-registration');
//       register();
//     })().catch((err) => {
//       console.error('Service worker registration failed:', err);
//     });
//   });
// }
